import React from "react";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const IconInvestments = ({ width = "24px", height = "24px", fill = "#000" }: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 17l4-4 4 4 8-8" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default IconInvestments;